import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-manage-warranty-dealer-code',
  templateUrl: './manage-warranty-dealer-code.component.html',
  styleUrls: ['./manage-warranty-dealer-code.component.scss']
})
export class ManageWarrantyDealerCodeComponent implements OnInit {
  @Output() dataToWDC = new EventEmitter<any>();
  public userId: any;
  public code: any = '';
  public description: any = '';
  public codeUpdate: any;
  public updateDescription: any;
  public WDCList1:any;
  public WDCList: any = [];
  public WDCListget: any = [];
  public errorMessage: any;
  public infotab: boolean = false;
  public hintstab: boolean = false;
  public submittab: boolean = false;
  public isHighlighted:boolean = false;
  public tokenObj: any;

  constructor(private service: ApifirstService, public router: Router, private translate:TranslateService) { }

  ngOnInit(): void {
    this.service.userId.subscribe((data) => {
      this.userId = data
    })
    this.service.getWDC(this.userId).subscribe((data) => {
      console.log("in wdc manage")
      this.WDCList1=[...data]
      this.WDCList = [...data]
    })

    this.service.tokenObj.subscribe((data) => {
      this.tokenObj = data
      this.code = this.tokenObj.marketCountry;
    })

    this.service.HighlightAddManageWarrantyCode.subscribe((data:boolean)=> {
     if(data) {
      this.isHighlighted = data;
      setTimeout(() => {
        this.isHighlighted = false;
       }, 5000);
     }
    })

  }
  errorMessage1: any
  addWDC() {
    this.showError = false
    this.errorMessage = ''
    this.errorMessage1 = ''
    if (this.code.length == 0 && this.description.length == 0) {
      this.errorMessage = this.translate.instant('Code cannot be empty')
      this.errorMessage1 = this.translate.instant('Description cannot be empty')
    }
    else if (this.code.length == 0 && this.description.length != 0 && this.description.length < 80) {
      this.errorMessage = this.translate.instant('Code cannot be empty')
    }
    else if (this.code.length == 0 && this.description.length > 80) {
      this.errorMessage = this.translate.instant('Code cannot be empty')
      this.errorMessage1 = this.translate.instant('Description can be maximum of 80 alphanumeric characters long')
    }
    else if (this.code.length != 0 && this.description.length == 0) {
      this.errorMessage1 = this.translate.instant('Description cannot be empty')
      if (/[^A-Za-z0-9 ]/g.test(this.code)) {
        this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      }
      if (this.code.length > 10) {
        this.errorMessage = this.translate.instant('Code can be maximum of 10 alphanumeric characters long')
      }
      if (/[^A-Za-z0-9 ]/g.test(this.code) && this.code.length > 10) {
        this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      }
    } else if (this.code.length != 0 && this.description.length == 0 && /[^A-Za-z0-9 ]/g.test(this.code)) {
      this.errorMessage1 = this.translate.instant('Description cannot be empty')
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
    }
    else if (/[^A-Za-z0-9 ]/g.test(this.code) && this.description.length == 0) {
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      this.errorMessage1 = this.translate.instant('Description cannot be empty')
    }
    else if (/[^A-Za-z0-9 ]/g.test(this.code) && this.description.length > 80) {
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      this.errorMessage1 = this.translate.instant('Description can be maximum of 80 alphanumeric characters long')
    }
    else if (this.code.length == 0 && this.description.length > 80) {
      this.errorMessage = this.translate.instant('Code cannot be empty')
      this.errorMessage1 = this.translate.instant('Description can be maximum of 80 alphanumeric characters long')
    }
    else if (this.code.length > 10 && /[^A-Za-z0-9 ]/g.test(this.code) == false && this.description.length == 0) {
      this.errorMessage = this.translate.instant('Code can be maximum of 10 alphanumeric characters long')
      this.errorMessage1 = this.translate.instant('Description cannot be empty')
    }
    else if (/[^A-Za-z0-9 ]/g.test(this.code) && this.description.length < 80) {
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')

    }
    else if (this.code.length > 10 && /^[^A-Za-z0-9 ]/g.test(this.code) == false && this.description.length > 80) {
      this.errorMessage = this.translate.instant('Code can be maximum of 10 alphanumeric characters long')
      this.errorMessage1 = this.translate.instant('Description can be maximum of 80 alphanumeric characters long')
    } else if (this.code.length > 10 && /^[^A-Za-z0-9 ]/g.test(this.code) == false && this.description.length < 80) {
      this.errorMessage = this.translate.instant('Code can be maximum of 10 alphanumeric characters long')
    }
    else if (this.code.length > 10 && /^[^A-Za-z0-9 ]/g.test(this.code) && this.description.length < 80) {
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
    }
    else if (/[^A-Za-z0-9 ]/g.test(this.code) == false && /^[^A-Za-z0-9 ]/g.test(this.code) == false && this.description.length > 80) {
      this.errorMessage1 = this.translate.instant('Description can be maximum of 80 alphanumeric characters long')
    }
    else if (this.code.length < 10 && /^[^A-Za-z0-9 ]/g.test(this.code) && this.description.length < 80) {
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
    }

    else {
      for (let i of this.WDCList) {
        console.log("error")
        if (i.code.toLowerCase() == this.code.toLowerCase()) {
          this.errorMessage = this.translate.instant('The code was added already')
          this.showError = true
          break;
        }
        else {
          this.showError = false
        }
      }
      console.log(this.showError, "error is ")
      if (!this.showError) {
        console.log(" no error")
        let req = {
          code: this.code,
          userId: this.userId,
          description: this.description,
          newCode: this.code

        }
        this.service.addUpdateWDC(req).subscribe((data) => {
          this.WDCList = data
          this.service.WDCListservice.next(this.WDCList)
          this.code = ''
          this.description = ''
        })
      }
    }

  }
  showError: any = false;
  updateWDC(code: any, description: any, ind: any) {
    console.log("c and d", code ,description,)
    this.errorMessage = ''
    this.errorMessage1 = ''
    if (code.length == 0 && description.length == 0) {
      this.errorMessage = this.translate.instant('Code cannot be empty')
      this.errorMessage1 = this.translate.instant('Description cannot be empty')
      this.code = code
      this.description = description
      this.service.getWDC(this.userId).subscribe((data) => {
        this.WDCList = data
        console.log(this.WDCList)

      })
    }
    else if (code.length == 0 && description.length != 0 && description.length < 80) {
      this.errorMessage = this.translate.instant('Code cannot be empty')
      this.code = code
      this.description = description
      this.service.getWDC(this.userId).subscribe((data) => {
        this.WDCList = data
      })
    }
    else if (code.length == 0 && description.length > 80) {
      this.errorMessage = this.translate.instant('Code cannot be empty')
      this.errorMessage1 = this.translate.instant('Description can be maximum of 80 alphanumeric characters long')
      this.code = code
      this.description = description
      this.service.getWDC(this.userId).subscribe((data) => {
        this.WDCList = data
      })
    }
    else if (code.length != 0 && description.length == 0) {
      this.errorMessage1 = this.translate.instant('Description cannot be empty')
      if (/[^A-Za-z0-9 ]/g.test(code)) {
        this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      }
      if (code.length > 10) {
        this.errorMessage = this.translate.instant('Code can be maximum of 10 alphanumeric characters long')
      }
      if (/[^A-Za-z0-9 ]/g.test(code) && code.length > 10) {
        this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      }
      this.code = code
      this.description = description
    } else if (code.length != 0 && description.length == 0 && /[^A-Za-z0-9 ]/g.test(code)) {
      this.errorMessage1 = this.translate.instant('Description cannot be empty')
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      this.service.getWDC(this.userId).subscribe((data) => {
        this.WDCList = data
      })
      this.code = code
      this.description = description
    }
    else if (/[^A-Za-z0-9 ]/g.test(code) && description.length == 0) {
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      this.errorMessage1 = this.translate.instant('Description cannot be empty')
      this.service.getWDC(this.userId).subscribe((data) => {
        this.WDCList = data
      })
      this.code = code
      this.description = description
    }
    else if (/[^A-Za-z0-9 ]/g.test(code) && description.length > 80) {
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      this.errorMessage1 = this.translate.instant('Description can be maximum of 80 alphanumeric characters long')
      this.service.getWDC(this.userId).subscribe((data) => {
        this.WDCList = data
      })
      this.code = code
      this.description = description
    }
    else if (code.length == 0 && description.length > 80) {
      this.errorMessage = this.translate.instant('Code cannot be empty')
      this.errorMessage1 = this.translate.instant('Description can be maximum of 80 alphanumeric characters long')
      this.service.getWDC(this.userId).subscribe((data) => {
        this.WDCList = data
      })
      this.code = code
      this.description = description
    }

    else if (/[^A-Za-z0-9 ]/g.test(code) && description.length < 80) {
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      this.service.getWDC(this.userId).subscribe((data) => {
        this.WDCList = data
      })
      this.code = code
      this.description = description
    }
    else if (code.length > 10 && /^[^A-Za-z0-9 ]/g.test(code) == false && description.length > 80) {
      this.errorMessage = this.translate.instant('Code can be maximum of 10 alphanumeric characters long')
      this.errorMessage1 = this.translate.instant('Description can be maximum of 80 alphanumeric characters long')
      this.code = code
      this.description = description
    } else if (code.length > 10 && /^[^A-Za-z0-9 ]/g.test(code) == false && description.length < 80) {
      this.errorMessage = this.translate.instant('Code can be maximum of 10 alphanumeric characters long')
      this.code = code
      this.description = description
    }
    else if (code.length > 10 && /^[^A-Za-z0-9 ]/g.test(code) && description.length < 80) {
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      this.code = code
      this.description = description
    }
    else if (/[^A-Za-z0-9 ]/g.test(code) == false && /^[^A-Za-z0-9 ]/g.test(code) == false && description.length > 80) {
      this.errorMessage1 = this.translate.instant('Description can be maximum of 80 alphanumeric characters long')
      this.code = code
      this.description = description
    }
    else if (code.length < 10 && /^[^A-Za-z0-9 ]/g.test(code) && description.length < 80) {
      this.errorMessage = this.translate.instant('Code be only up to 10 characters long and has to be alphanumeric characters')
      this.code = code
      this.description = description
    }
    else {
      this.service.getWDC(this.userId).subscribe((data) => {
        this.WDCListget = data
        console.log(this.WDCListget)
        console.log(ind)
        var c: any = {}
        c = this.WDCListget[ind]
        console.log(c, this.WDCListget, ind)
        let oldcode = c.code
        let olddescription = c.description
        let req = {
          "code": oldcode,
          "userId": this.userId,
          "description": description,
          "newCode": code
        }
        console.log("wdc service mwdc1",this.service.WDCListservice)
        this.service.addUpdateWDC(req).subscribe((data) => {
          this.WDCList = data
          // this.WDCList1=data
          if(data.length>0){
          this.service.getWDC(this.userId).subscribe((data) => {
            this.WDCList = data

            this.WDCList1=data
            this.service.WDCListservice.next(this.WDCList)

          })
          this.service.WDCListservice.next(this.WDCList)
        }
        })


      })
      this.code = '';
      this.description = '';



  }
  this.service.getWDC(this.userId).subscribe((data) => {
    this.WDCList = data

    this.WDCList1=data
    this.service.WDCListservice.next(this.WDCList)

  })

  }


  deleteWDC(code: any, description: any, ind: any) {


    console.log(code, description, "code desc")

    if (code == '' || description == '') {
      this.service.getWDC(this.userId).subscribe((data) => {
        this.WDCListget = data
        console.log(this.WDCListget)
        console.log(ind)
        var c: any = {}
        c = this.WDCListget[ind]
        console.log(c, this.WDCListget, ind)
        code = c.code
        description = c.description
        let req = {
          "code": code,
          "userId": this.userId,
          "description": description,
        }
        this.service.deleteWDC(req).subscribe((data) => {
          this.WDCList = data
          this.service.WDCListservice.next(this.WDCList)
          this.service.getWDC(this.userId).subscribe((data) => {
            this.WDCList = data

            this.service.WDCListservice.next(this.WDCList)

          })
        })
      })


    }
    else {
      let req = {
        "code": code,
        "userId": this.userId,
        "description": description
      }
      this.service.deleteWDC(req).subscribe((data) => {
        this.WDCList = data
        this.service.getWDC(this.userId).subscribe((data) => {
          this.WDCList = data
          this.service.WDCListservice.next(this.WDCList)

        })
      })

    }

    if (this.WDCListget.length == 1 && this.WDCListget[0].code == '' && this.WDCListget[0].description == '') {
      this.WDCList = []
      this.service.WDCListservice.next(this.WDCList)

    }
    this.service.WDCListservice.next(this.WDCList)

  }
  hotlineSubmit() {
    this.infotab = false;
    this.service.infotab.next(this.infotab)
    this.hintstab = false;
    this.service.hintstab.next(this.hintstab)
    this.submittab = true;
    this.service.submittab.next(this.submittab)
    this.router.navigateByUrl('/hotline')
  }

}
